import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';


// CHILD
const ImageCropper = ({
  crop,
  setCrop,
  zoom,
  setZoom,
  setCoord,
  image,
  imageProperties
}) => {
  const onCropComplete = useCallback(
    (croppedArea, croppedAreaPixels) => setCoord(croppedAreaPixels),
    [],
  );
  return (
    <div
      className={`cropper-container-${imageProperties.containerHeight}`}
    >
      <Cropper
        image={image}
        crop={crop}
        zoom={zoom}
        cropShape="rect"
        showGrid={false}
        aspect={imageProperties.aspect}
        onCropChange={setCrop}
        onCropComplete={onCropComplete}
        onZoomChange={setZoom}
        objectFit="cover"
      />
    </div>
  );
};

export default ImageCropper;
